// todo: rename file to brandSafety.ts

import {
  CategoryType,
  GarmRiskLevelType,
  IabBrandSafetyCategoryType,
  IabBrandSafetyRiskLevelType,
} from '@insights_module/types/BrandSafety';

export const GARM_CATEGORIES = {
  adult_explicit_content: 'adult_explicit_content' as CategoryType,
  arms_ammunition: 'arms_ammunition' as CategoryType,
  crime_harmful_act: 'crime_harmful_act' as CategoryType,
  death_injury_military_conflict: 'death_injury_military_conflict' as CategoryType,
  debated_social: 'debated_social' as CategoryType,
  hate_speech: 'hate_speech' as CategoryType,
  illegal_drugs: 'illegal_drugs' as CategoryType,
  obscenity: 'obscenity' as CategoryType,
  online_piracy: 'online_piracy' as CategoryType,
  spam_harmful: 'spam_harmful' as CategoryType,
  terrorism: 'terrorism' as CategoryType,
};

export const GARM_CATEGORIES_ARRAY = Object.values(GARM_CATEGORIES);

export const GARM_RISK_LEVEL = {
  unrelated: 'unrelated' as GarmRiskLevelType,
  low: 'low' as GarmRiskLevelType,
  medium: 'medium' as GarmRiskLevelType,
  high: 'high' as GarmRiskLevelType,
  floor: 'floor' as GarmRiskLevelType,
};

export const IAB_BRAND_SAFETY_CATEGORIES = {
  adult_content: 'adult_content' as IabBrandSafetyCategoryType,
  arms: 'arms' as IabBrandSafetyCategoryType,
  crime: 'crime' as IabBrandSafetyCategoryType,
  death_injury: 'death_injury' as IabBrandSafetyCategoryType,
  drugs: 'drugs' as IabBrandSafetyCategoryType,
  hate_speech: 'hate_speech' as IabBrandSafetyCategoryType,
  military_conflict: 'military_conflict' as IabBrandSafetyCategoryType,
  obscenity: 'obscenity' as IabBrandSafetyCategoryType,
  online_piracy: 'online_piracy' as IabBrandSafetyCategoryType,
  spam_harmful: 'spam_harmful' as IabBrandSafetyCategoryType,
  terrorism: 'terrorism' as IabBrandSafetyCategoryType,
  tobacco: 'tobacco' as IabBrandSafetyCategoryType,
};

export const IAB_BRAND_SAFETY_CATEGORY_ARRAY = Object.values(IAB_BRAND_SAFETY_CATEGORIES);

export const IAB_BRAND_SAFETY_RISK_LEVEL = {
  unrelated: 'unrelated' as IabBrandSafetyRiskLevelType,
  likely_unrelated: 'likely unrelated' as IabBrandSafetyRiskLevelType,
  likely_related: 'likely related' as IabBrandSafetyRiskLevelType,
  related: 'related' as IabBrandSafetyRiskLevelType,
};
